import { Button } from 'antd';
import React, { FC, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import BottomBox from 'components/BottomBox';
import ScrollTop from 'components/ScrollTop';
import Toast from 'components/Toast';
import { PlaidBankCardItem } from 'components/vendor/plaid';
import security from 'stores/security';
import API from 'utils/API';
import { formatMoney } from 'utils/format';
import http from 'utils/http';
import { getMaskText } from 'utils/util';
import './style.scss';

const Confirm: FC<{ isIRA?: boolean }> = ({ isIRA }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state as {
        params: any;
        selectedBank: PlaidBankCardItem;
    } | null;
    const { params, selectedBank } = locationState || {};
    const [loading, setLoading] = useState(false);

    if (!locationState) {
        return <Navigate to=".." replace />;
    }

    const goNext = () => {
        navigate('../complete', {
            state: {
                type: 'success',
                source: 'withdraw',
                amount: formatMoney(Number(params.amount).toFixed(2), '$')
            }
        });
    };

    const handleSubmit = async () => {
        setLoading(true);

        const { account_id, amount, reason, tax_year } = params;

        try {
            if (security.optStatus) {
                await http.post(
                    API.TRADE.funding.withdrawAch(),
                    {
                        ...params,
                        ach_card_id: locationState.selectedBank.id,
                        source: locationState.selectedBank.id_source,
                        customer_id: security.currentCustomerId
                    },
                    {
                        params: {
                            customer_id: security.currentCustomerId,
                            account_id: security.currentAccountId
                        }
                    }
                );

                goNext();
            } else {
                const submitParams = {
                    account_id,
                    amount,
                    currency: 'USD',
                    reason,
                    tax_year
                };

                await http.post(
                    API.TRADE.funding.submitWithDraw(),
                    {
                        ...submitParams,
                        ach_card_id: locationState.selectedBank.id,
                        source: locationState.selectedBank.id_source,
                        customer_id: security.currentCustomerId,
                        tax_rate: isIRA ? Number(params.tax_rate) || 0 : undefined
                    },
                    {
                        params: {
                            customer_id: security.currentCustomerId,
                            account_id: security.currentAccountId
                        }
                    }
                );

                goNext();
            }
        } catch (error) {
            await Toast.show(error);

            // code: 11084 超时，回到第一步
            if (error.error_code * 1 === 11084) {
                navigate('..');
            }
        }

        setLoading(false);
    };

    const { mask, account, institution_id, institution_name, subtype } = selectedBank!;
    const currAccount = institution_id === 'ins_56' ? getMaskText(mask) || account : account;

    return (
        <div className="withdraw-ach-confirm-root">
            <ScrollTop />
            <h3 className="main-title">
                {isIRA ? __('Confirm Distribution Information') : __('Confirm Withdrawal Information')}
            </h3>
            <div className="info-box">
                <div className="info mb-3">
                    <div className="label">{__('Amount')}</div>
                    <div className="value">{formatMoney(Number(params.amount).toFixed(2), '$')}</div>
                </div>
                <div className="info mb-3">
                    <div className="label">{__('Bank Account')}</div>
                    <div className="value">{`${institution_name.toUpperCase()} - ${subtype.toUpperCase()} - ${currAccount}`}</div>
                </div>
            </div>
            <BottomBox className="btn-box">
                <Button
                    className="btn-important"
                    type="primary"
                    block
                    loading={loading}
                    disabled={loading}
                    onClick={handleSubmit}>
                    {__('Confirm')}
                </Button>
            </BottomBox>
        </div>
    );
};

export default Confirm;
